import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import * as moment from "moment";
import { makeStyles } from "@mui/styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { gasEstimateUnstake } from "../../config/gasEstimation";
import environmentVariables from "../../config/environmentVariables";
import TransactionLoader from "../../Components/TransactionLoader/TransactionLoader";
import CircularLoader from "../../Components/CircularLoader/CircularLoader";
import { userBalanceContext } from "../../context/userBalanceContext";
import axios from "axios";
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
    "@media (max-width: 400px)": {
      maxWidth: "220px",
      minWidth: "320px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));

const Root = styled.div`
  background-color: ${(p) => p.theme.colors.cardBgColor};
  /* padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.sm} */
  /* padding: 20px; */
  /* ${(p) => p.theme.spacing.xl} ${(p) => p.theme.spacing.sm}; */
  margin-bottom: ${(p) => p.theme.spacing.sm};
  border-radius: 20px;
`;
const AddImageWrapper = styled.div`
  position: relative;
  display: flex;
  width: 90%;
  margin: 5%;
  // cursor: pointer;
  border-radius: 20px;
  background-color: #262a2d;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  overflow: hidden;
`;

const Button = styled.button`
  background: #fff;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 15px 20px;
  color: #000;
  border: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  transition: 0.5s;
  margin-top: 10px;
  &:hover {
    background: #1c3741;
    color: #208da5;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* margin-top: ${(p) => p.theme.spacing.lg}; */
  margin: 10px 15px;
  /* margin: 20px 0; */
`;

const Card = styled.div``;
const Name = styled.div`
  margin-top: ${(p) => p.theme.spacing.sm};
  font-weight: ${(p) => p.theme.font.weight.bold};
  font-family: ${(p) => p.theme.font.family.Lato};
  padding: 0 15px;
  font-size: 18px;
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.lg};
  }
`;
const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(p) => p.theme.colors.cardFontColor};
  margin-top: ${(p) => p.theme.spacing.xs};
  margin-bottom: ${(p) => p.theme.spacing.xs};
`;

const Text = styled.div`
  word-break: break-all;
  color: #999999;
  font-size: 14px;
  font-family: "lato";
  font-weight: 500;
  min-height: 65px;
  overflow: hidden;
  letter-spacing: 1px;
  text-align: justify;
`;

const Icon = styled.img`
  border-radius: 20px;
  padding: 20px;
  max-height: 160px;
`;

const StakeContainer = styled.div``;
const StakeWrapper = styled.div`
  padding: 0 15px;
`;
const StakeTimeWrapper = styled.div`
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  align-items: start;
  text-align: center;
  margin: 15px 0;
`;
const StakeTimeText = styled.text`
  font-size: 16px;
  font-weight: 500;
  color: #8a8aa0;
  @media (max-width: 1024px) {
    font-size: 18px;
  }
`;
const StakeTimeValue = styled.text`
  font-size: 16px;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;
const NftAmountConfirmHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmSubHead3 = styled.div`
  font-size: 16px;
  color: #fff;
`;
const NftAmountConfirmSubHead2 = styled.div`
  font-size: 16px;
  color: #bbb;
`;
const NftAmountConfirmHeadPur = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;
const NftNameConfirmHead = styled.div`
  font-size: 24px;
  font-weight: 600;
`;
const NftNameConfirm = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: space-between;
`;
const StakeTimeValueWrapper = styled.div`
  /* width: 60%; */
  display: flex;
  justify-content: end;
  align-items: center;
  text-align: end;
`;

const StackTimeTextWrapper = styled.div`
  /* width: 40%; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: start;
`;

const TokenIdText = styled.div`
  font-size: 24px;
  font-family: "Lato";
`;

const Button1 = styled(Button)`
  background-color: red;
`;
const NftCategory = styled.div`
  font-size: 9px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  /* background-color: #d3b1f3; */
  background-color: ${(props) =>
    props.common ? "#dddddd" : props.uncommon ? "#22363e" : "initial"};
  padding: 7px 12px;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
  right: -5px;
  /* opacity: 0.7; */
  ${(p) =>
    p.uncommon &&
    `
    background-color: #22363e;
    color: #74bccb;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #392e4a;
    color: #a98bc5;
  `};
`;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
`;

const NftNameConfirmHeadHash = styled.div`
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  border: 1px solid #31393c;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 35px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  /* width: 105px; */
`;
const DialogStyledUpdate = styled(Dialog)``;

const AddNftsCard = (props) => {
  const classes = useStyles();
  const [stakeConfirmPopup, setStakeConfirmPopup] = useState(false);
  const [unStakeConfirmPopup, setUnStakeConfirmPopup] = useState(false);
  const [isUnstakeClicked, setIsUnstakedClicked] = useState(false);
  const { userBalance, setUserBalance } = useContext(userBalanceContext);
  const [unstakeTransactionFees, setUnstakeTransactionFees] = useState(null);
  const [nftDetail,setNftDetail]=useState({});
  const {
    stake,
    isWithdraw,
    setIsWithdraw,
    withdraw,
    address,
    tokenID,
    setIsWithdrawError,
    setMessage,
    timeStamp = 0,
    
  } = props;
  console.log(nftDetail,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')
  const getSingleNFTDetails=async ()=>{
    axios.get(`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/${address}/${tokenID}`).then(response=>{
      setNftDetail(response?.data)
    }).catch(err=>{
      console.log(err)
    })
  }
  useEffect(()=>{
    getSingleNFTDetails();
  },[])
  const handleUnstake = async () => {
    console.log('jjjjjjjjjjjjjjjjjjjj')
    if (userBalance.MATIC < 0.04) {
      setMessage("Insufficient Matic");
      setIsWithdrawError(true);
      return;
    }
    setIsUnstakedClicked(true);
    const gas = await gasEstimateUnstake(address, tokenID, props.userAddress);
    console.log(gas, nftDetail, "unstake gas ------------------------>");
  
    setUnstakeTransactionFees(gas);
    setUnStakeConfirmPopup(true);
    setIsUnstakedClicked(false);
  };

  return (
    <>
      {isWithdraw && <TransactionLoader />}
      <Root>
        <Card style={{ gridGap: "10px" }}>
          <AddImageWrapper>
            <Icon
              src={`${environmentVariables?.cdnUrl}${nftDetail?.skinId}.png`}
            />
            <NftCategory uncommon>Uncommon</NftCategory>
          </AddImageWrapper>
          <Name> {nftDetail?.name}</Name>
          {/* <Line></Line> */}
          {/* <Text>{nftDetail?.description?.slice(0,85)} ...</Text> */}
          {/* <TokenIdText>{nftDetail?.tokenId}</TokenIdText> */}
          {timeStamp && (
            <StakeContainer>
              <StakeWrapper>
                <StakeTimeWrapper>
                  <StackTimeTextWrapper>
                    <StakeTimeText>Hash Rate :</StakeTimeText>
                  </StackTimeTextWrapper>
                  <StakeTimeValueWrapper>
                    <StakeTimeValue># {nftDetail.hash}</StakeTimeValue>
                  </StakeTimeValueWrapper>
                </StakeTimeWrapper>

                <StakeTimeWrapper>
                  <StackTimeTextWrapper>
                    <StakeTimeText> Staked Date </StakeTimeText>
                  </StackTimeTextWrapper>
                  <StakeTimeValueWrapper>
                    <StakeTimeValue>
                      {moment(timeStamp * 1000).format("DD MMM,  YYYY")}
                    </StakeTimeValue>
                  </StakeTimeValueWrapper>
                </StakeTimeWrapper>

                {/* <StakeTimeWrapper>
              <StackTimeTextWrapper>
                <StakeTimeText> Stake for :</StakeTimeText>
              </StackTimeTextWrapper>
              <StakeTimeValueWrapper>
                <StakeTimeValue>
                  {" "}
                  {parseInt(
                    (parseInt(Number(new Date()) / 1000) - timeStamp) / 86400
                  )}{" "}
                  days
                </StakeTimeValue>
              </StakeTimeValueWrapper>
            </StakeTimeWrapper> */}
              </StakeWrapper>
            </StakeContainer>
          )}
          <ButtonContainer>
            {stake && (
              <Button
                radius="xl"
                top="xs"
                bottom="xs"
                font="xs"
                sbottom="xs"
                // onClick={() => {
                //   stake(address, tokenID);
                // }}
                onClick={() => {
                  setStakeConfirmPopup(true);
                  // console.log(nftDetail)
                }}
              >
                Stake
              </Button>
            )}

            <Dialog
              open={stakeConfirmPopup}
              onClose={() => setStakeConfirmPopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <ButtonCancel
                onClick={() => setStakeConfirmPopup(false)}
                color="primary"
              >
                X
              </ButtonCancel>
              <div className={classes.customButton}>
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    textAlign: "left",
                    fontSize: "28px",
                    fontWeight: "500",
                    padding: "0",
                  }}
                >
                  Lock in your NFT Stake
                </DialogTitle>
                <DialogContent style={{ padding: "0 0 40px" }}>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{
                      textAlign: "left",
                      color: "#bbb",
                      fontSize: "16px",
                    }}
                  >
                    Double-check your details to complete the transaction
                  </DialogContentText>
                </DialogContent>

                <NftNameConfirm>
                  <NftNameConfirmHead>{nftDetail.name}</NftNameConfirmHead>
                  <NftNameConfirmHeadHash>
                    # {nftDetail.hash}
                  </NftNameConfirmHeadHash>
                </NftNameConfirm>

                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>Lord Required :</NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead3>10 Lord</NftAmountConfirmSubHead3>
                </NftAmountConfirmHeadPur>
                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>
                    Reward Earned/Day:
                  </NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead3>3 Months</NftAmountConfirmSubHead3>
                </NftAmountConfirmHeadPur>
                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>
                    Transaction Fee :
                  </NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead3>
                    0.015 Matic
                  </NftAmountConfirmSubHead3>
                </NftAmountConfirmHeadPur>

                <DialogActions>
                  <PayButtons>
                    <ButtonConfirm
                      onClick={() => {
                        stake(address, tokenID);
                        setStakeConfirmPopup(false);
                      }}
                      color="primary"
                      autoFocus
                    >
                      Confirm
                    </ButtonConfirm>
                  </PayButtons>
                </DialogActions>
              </div>
            </Dialog>

            {withdraw && (
              <Button
                bdcolor="skyColor"
                color="skyColor"
                top="xs"
                bottom="xs"
                radius="xl"
                // onClick={() => {
                //   withdraw(address, tokenID);
                // }}
                //disabled unstaking until further notice because of some issue
                disabled={unStakeConfirmPopup}
                onClick={handleUnstake}
              >
                {isUnstakeClicked == true ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularLoader></CircularLoader>
                    </div>
                  </>
                ) : (
                  "Unstake"
                )}
              </Button>
            )}

            {/* <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={unStakeConfirmPopup}
          onClose={() => setUnStakeConfirmPopup(false)}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              maxWidth: 500,
              borderRadius: "md",
              p: 3,
              boxShadow: "lg",
            }}
          >
            <ModalClose variant="plain" sx={{ m: -2 }} />
            <Typography
              component="h2"
              id="modal-title"
              level="h4"
              textColor="inherit"
              fontWeight="lg"
              mb={1}
            >
              Are you want to sure to want to Unstake a nft
            </Typography>
            <Typography id="modal-desc" textColor="text.tertiary">
              Make sure you're Unstaking a NFTs
            </Typography>
            <button
              onClick={() => {
                withdraw(address, tokenID);
                setUnStakeConfirmPopup(false);
              }}
            >
              {" "}
              Confirm UnStake
            </button>
          </Sheet>
        </Modal> */}

            <DialogStyledUpdate
              open={unStakeConfirmPopup}
              onClose={() => setUnStakeConfirmPopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                sx: { overflow: "initial", backgroundColor: "transparent" },
              }}
            >
              <ButtonCancel
                onClick={() => setUnStakeConfirmPopup(false)}
                color="primary"
              >
                X
              </ButtonCancel>
              <div className={classes.customButton}>
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    textAlign: "left",
                    fontSize: "28px",
                    fontWeight: "500",
                    padding: "0",
                  }}
                >
                  Set your NFT free
                </DialogTitle>
                <DialogContent style={{ padding: "0 0 40px" }}>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{
                      textAlign: "left",
                      color: "#bbb",
                      fontSize: "16px",
                    }}
                  >
                    Double-check the details to unstake your NFT
                  </DialogContentText>
                </DialogContent>

                <NftNameConfirm>
                  <NftNameConfirmHead>{nftDetail.name}</NftNameConfirmHead>
                  <NftNameConfirmHeadHash>
                    # {nftDetail.hash}
                  </NftNameConfirmHeadHash>
                </NftNameConfirm>

                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>
                    Withdrawl Fee(10%) :
                  </NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead3>
                    {nftDetail?.price * 0.1}
                  </NftAmountConfirmSubHead3>
                </NftAmountConfirmHeadPur>
                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>Lord burn(50%)</NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead3>10 lord</NftAmountConfirmSubHead3>
                </NftAmountConfirmHeadPur>
                <NftAmountConfirmHeadPur>
                  <NftAmountConfirmHead2>
                    Transaction Fee :
                  </NftAmountConfirmHead2>
                  <NftAmountConfirmSubHead3>
                    {unstakeTransactionFees == null ||
                    unstakeTransactionFees == undefined
                      ? "0.03857 Matic"
                      : `${parseFloat(unstakeTransactionFees).toFixed(
                          4
                        )} Matic`}
                  </NftAmountConfirmSubHead3>
                </NftAmountConfirmHeadPur>

                <DialogActions>
                  <PayButtons>
                    <ButtonConfirm
                      onClick={() => {
                        withdraw(address, tokenID, nftDetail);
                        setUnStakeConfirmPopup(false);
                        setIsWithdraw(true);
                      }}
                      color="primary"
                      autoFocus
                    >
                      Confirm
                    </ButtonConfirm>
                  </PayButtons>
                </DialogActions>
              </div>
            </DialogStyledUpdate>
          </ButtonContainer>
        </Card>
      </Root>
    </>
  );
};

export default AddNftsCard;
